export const server =
  // "http://ec2-13-125-213-66.ap-northeast-2.compute.amazonaws.com:8080";
  "api";
  // "http://localhost:8080";
